<template>
  <v-container grid-list-md class="text-xs-center">
    <v-layout justify-center row wrap>
      <v-flex md12 class="mb-5">
        <h1 class="mb-3">Statistics of Robonomics network activity</h1>
        <div class="title">
          <strong class="green--text text--lighten-2" v-if="connected">dapp connected</strong>
          <strong class="red--text text--lighten-2" v-else>lost connection</strong>
        </div>
      </v-flex>
    </v-layout>
    <v-layout justify-center row wrap>
      <v-flex md12 class="mb-5">
        <h2 class="mb-3">
          Robotics under Ethereum control
          <v-btn
            outline
            small
            :color="isShowContracts ? 'indigo lighten-4' : 'indigo lighten-3'"
            @click="isShowContracts = !isShowContracts"
            class="mt-0"
          >
            <span v-if="isShowContracts">less</span>
            <span v-else>more</span>
          </v-btn>
        </h2>

        <strong>Total launched by Robonomics gen 5</strong>
        <div v-show="!isShowContracts" class="mt-3">
          last month
          <br>
          <strong style="font-size: 36px">{{li.create.m}}</strong>
        </div>
        <div v-show="isShowContracts">
          <v-layout justify-center row wrap class="mt-3">
            <v-flex md3>
              last 24 hours
              <br>
              <strong>{{li.create.d}}</strong>
            </v-flex>
            <v-flex md3>
              last week
              <br>
              <strong>{{li.create.w}}</strong>
            </v-flex>
            <v-flex md3>
              last month
              <br>
              <strong>{{li.create.m}}</strong>
            </v-flex>
          </v-layout>
          <v-layout justify-center row wrap>
            <v-flex md9>
              <v-divider class="mb-5"/>
            </v-flex>
          </v-layout>

          <strong>Amount of finalized contract liabilities</strong>
          <v-layout justify-center row wrap class="mt-3">
            <v-flex md3>
              last 24 hours
              <br>
              <strong>{{li.fin.d}}</strong>
            </v-flex>
            <v-flex md3>
              last week
              <br>
              <strong>{{li.fin.w}}</strong>
            </v-flex>
            <v-flex md3>
              last month
              <br>
              <strong>{{li.fin.m}}</strong>
            </v-flex>
          </v-layout>
          <v-layout justify-center row wrap>
            <v-flex md9>
              <v-divider class="mb-5"/>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <v-layout justify-center row wrap>
      <v-flex md12 class="mb-5">
        <h2 class="mb-3">
          Amount of recycling gas
          <v-btn
            outline
            small
            :color="isShowGas ? 'indigo lighten-4' : 'indigo lighten-3'"
            @click="isShowGas = !isShowGas"
            class="mt-0"
          >
            <span v-if="isShowGas">less</span>
            <span v-else>more</span>
          </v-btn>
        </h2>

        <strong>Full amount of utilized gas</strong>
        <div v-show="!isShowGas" class="mt-3">
          last month
          <br>
          <strong style="font-size: 36px">{{gas.full.m}}</strong>
        </div>
        <div v-show="isShowGas">
          <v-layout justify-center row wrap class="mt-3">
            <v-flex md3>
              last 24 hours
              <br>
              <strong>{{gas.full.d}}</strong>
            </v-flex>
            <v-flex md3>
              last week
              <br>
              <strong>{{gas.full.w}}</strong>
            </v-flex>
            <v-flex md3>
              last month
              <br>
              <strong>{{gas.full.m}}</strong>
            </v-flex>
          </v-layout>
          <v-layout justify-center row wrap>
            <v-flex md9>
              <v-divider class="mb-5"/>
            </v-flex>
          </v-layout>

          <strong>Profit amount of utilized gas</strong>
          <v-layout justify-center row wrap class="mt-3">
            <v-flex md3>
              last 24 hours
              <br>
              <strong>{{gas.fin.d}}</strong>
            </v-flex>
            <v-flex md3>
              last week
              <br>
              <strong>{{gas.fin.w}}</strong>
            </v-flex>
            <v-flex md3>
              last month
              <br>
              <strong>{{gas.fin.m}}</strong>
            </v-flex>
          </v-layout>
          <v-layout justify-center row wrap>
            <v-flex md9>
              <v-divider class="mb-5"/>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <v-layout justify-center row wrap>
      <v-flex md12 class="mb-5">
        <h2 class="mb-3">Robonomics token, XRT</h2>
        <strong>
          <Link type="address" :to="xrt.address" :text="xrt.name"/>
        </strong>
        <br>Token address:
        <small>{{xrt.address}}</small>
        <v-layout row wrap class="mt-3">
          <v-flex>
            <p>Total amount of XRT in circulation: {{totalSupply}} XRT</p>
            <p>Providers reward per tx ~ {{wn}} XRT</p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import config from "../../config";

export default {
  name: "home",
  data() {
    return {
      factory: config.FACTORY,
      xrt: config.XRT,
      isShowGas: false,
      isShowContracts: false
    };
  },
  computed: mapState("statistics", [
    "connected",
    "totalSupply",
    "wn",
    "gas",
    "li",
    "contracts"
  ])
};
</script>
